import { getImagesListAPI, deleteImageAPI } from "../api";
import { sortStringsStartingWithNumbers } from "@/utils";

export default {
  namespaced: true,

  state: {
    data: {
      openModal: false,
      imagesList: null,
      isLoading: false,
    },
  },

  getters: {
    getIsOpenModal: (state) => state.data.openModal,
    getImageLoading: (state) => state.data.isLoading,
  },

  actions: {
    actionGetImages({ commit, rootState }) {
      const { env } = rootState.selectEnv.data;
      commit("SET_IS_LOADING", true);
      return new Promise((resolve, reject) => {
        getImagesListAPI(env).then(
          (response) => {
            const orderedResponse = sortStringsStartingWithNumbers(response);
            commit("SET_IMAGES", orderedResponse);
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            resolve(orderedResponse);
          },
          (error) => {
            console.log(error);
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            reject(error);
          }
        );
      });
    },

    actionDeleteImage({ commit }, payload) {
      commit("SET_IS_LOADING", true);
      return new Promise((resolve, reject) => {
        deleteImageAPI(payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            console.log("err: ", err);
            reject(err);
          });
      });
    },

    setOpenModal({ commit }, payload) {
      const isOpenModal = payload;
      commit("SET_OPEN_MODAL", isOpenModal);
    },
  },

  mutations: {
    SET_OPEN_MODAL(state, data) {
      state.data.openModal = data;
    },
    SET_IMAGES(state, data) {
      state.data.imagesList = data;
    },
    SET_IS_LOADING(state, payload) {
      state.data.isLoading = payload;
    },
  },
};
